exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#varianceCardModal .v--modal-box.v--modal{min-height:410px!important;min-width:400px!important}#varianceCardModal .v-tabs__div:not(:last-child){padding-right:5px}#varianceCardModal .v-tabs__div{background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}#varianceCardModal .v-select__selection{font-size:12px!important}#varianceCardModal .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}#varianceCardModal .v-tabs{width:100%}.btnDisabled{pointer-events:none!important;color:#888!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-207b79bb","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/start/modals/variances/VarianceCard.vue
// module id = 2114
// module chunks = 0